import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ModalAction from '../../components/ModalAction';
import LoaderIcon from '../../images/icons/Loader';

const ThanksModal = ({ modalOpen, setModalOpen, modalMessage, modalError, setModalMessage, setModalError, subscription, isRedirect = false }) => {
	const auth = useSelector(state => state.auth);

	const [isLoading, setIsLoading] = useState(true);

	const onClearModal = () => {
		setModalOpen(false);
		setTimeout(() => {
			setModalMessage(null);
			setModalError(null);
		}, 400);
	};

	useEffect(() => {
		if (subscription) {
			setIsLoading(false);
			setModalMessage('Thank you!')
		}
	}, [subscription]);

	return (
		<ModalAction
			id="thanks-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size="sm"
		>
			<h2 className="h2 mb-4 pr-16 md:pr-20 leading-[0.9]">
				{modalMessage && <div dangerouslySetInnerHTML={{ __html: modalMessage }} />}
			</h2>
			{(isLoading && !modalError) ? (
				<div className="flex flex-col gap-1">
					<div className="animate-pulse bg-[#F2F2F2] rounded-full w-3/4 h-4 sm:h-3 sm:mt-1.5 inline-block" />
					<div className="animate-pulse bg-[#F2F2F2] rounded-full w-1/4 h-4 sm:h-3 sm:mt-1.5 inline-block" />
				</div>
			) : (isRedirect ? <div>You are going to be redirected...</div> : <div>You can close this window now</div>)}
			<div>
				<button
					className="btn-primary w-full mt-8"
					onClick={() => !isLoading && onClearModal()}
				>
					{isLoading ? (
						<div className="flex items-center justify-center py-1 pointer-events-none">
							<LoaderIcon className="animate-rotation w-6 h-6 text-white" />
						</div>
					) : (
						<span className="pointer-events-none">Okay</span>
					)}
				</button>
			</div>
			{modalError && (
				<div className="text-sm text-red-orange mt-2 font-medium">{modalError}</div>
			)}
		</ModalAction>
	);
};

export default ThanksModal;
